import { ChatEngine }  from "react-chat-engine";
import ChatFeed from './components/ChatFeed';
import LoginForm from './components/LoginForm';
import './App.css';
const App = () => {
    if(!localStorage.getItem('username'))return <LoginForm/>
    return (
        <ChatEngine
        height="100vh"
        projectID="66c4814b-482d-423c-b642-4fef72ec46a5"
        userName={localStorage.getItem('username')}
        userSecret={localStorage.getItem('password')}
        renderChatFeed={ (chatAppProps) => <ChatFeed {...chatAppProps }/>}
        />
    );
}
export default App;